export const nativeTokenAddress = '0x0000000000000000000000000000000000000000'
export const nativeTokenAddressAdditional = '0x0000000000000000000000000000000000001010'
export const maxLimitAmount = '115792089237316195423570985008687907853269984665640564039457584007913129639935'
